import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { tokens } from '@hotjar/hotsauce';
import FeedbackEmojis from '@hotjar/shared-assets/images/feedback/feedback-emojis.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 1px solid ${tokens.color.neutral_600};
  margin-bottom: ${tokens.spacer.x4};
  margin-left: 48px;
  padding: ${tokens.spacer.x1} 0 ${tokens.spacer.x1} 48px;
`;

const Caption = styled.p`
  text-align: center;
  margin-top: ${tokens.spacer.x1};
  max-width: 180px;
  font-size: 12px;
  opacity: 0.7;
`;

const Image = styled.img`
  height: 45px;
`;

const FeedbackButton = styled.a`
  font-family: ${tokens.FONT_FAMILY}, sans-serif, Arial;
  height: 30px;
  padding: 2px 10px;
  border-radius: 3px;
  border: 1px solid ${tokens.color.white};
  color: ${tokens.color.white};
  font-size: 14px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.7;
  background: transparent;
  outline: 0;

  &:hover,
  &:focus {
    color: ${tokens.color.white};
    opacity: 1;
    text-decoration: none;
  }
`;

interface FeedbackPromptProps {
  onCreateFeedback: () => void;
  siteId: string;
}

export function FeedbackPrompt({ onCreateFeedback, siteId }: FeedbackPromptProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Container>
      <Image src={FeedbackEmojis} alt="" />
      <Caption>{t('common:player.understand-what-people-love')}</Caption>
      <FeedbackButton
        rel="noreferrer"
        href={`/sites/${siteId}/feedback/create/`}
        onClick={onCreateFeedback}
        target="_blank"
      >
        {t('common:player.start-collecting-feedback-btn')}
      </FeedbackButton>
    </Container>
  );
}
